import styled from 'styled-components';
import { Typography } from 'antd';

// Identifiers that read as data (ticket numbers, IDs) in the mono face.
// Content, not chrome: use it in column renderers, never as a .ant-* rule.
const MonoText = styled(Typography.Text)`
  font-family: ${({ theme }) => theme.typography.fontFamily.secondary};
  font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
  font-size: 13px;
`;

export default MonoText;
